import { C as bind, S as create, _ as get2, a as listAttachmentDescriptions, b as deleteAttachmentDescription, c as getVersions, d as getRefusal, f as getNeedsAttention, g as getCounts, h as getCurrentVersion, i as setAttachmentDescription, l as getRequests, m as getFilterValues, n as unlink, o as list, p as getHistory, r as transition, s as importRequest, t as update, u as getRequest, v as exportRequests, x as createRemark, y as deleteRemark } from "./update.js";
import { mutationOptions, queryOptions, useMutation, useQuery } from "@tanstack/react-query";
//#region src/__generated__/internal/application/hooks/useBind.ts
const bindMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:requestId/tu-parts/:departmentId/:fileId" }];
function bindMutationOptions(config = {}) {
	const mutationKey = bindMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await bind({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Привязать актуальную часть ТУ к подразделению
* {@link /api/mdm/internal/api/internal/requests/:requestId/tu-parts/:departmentId/:fileId}
*/
function useBind(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? bindMutationKey();
	const baseOptions = bindMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/application/hooks/useCreate.ts
const createMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:requestId/final-decision" }];
function createMutationOptions(config = {}) {
	const mutationKey = createMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await create({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Создать черновик итогового решения
* {@link /api/mdm/internal/api/internal/requests/:requestId/final-decision}
*/
function useCreate(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? createMutationKey();
	const baseOptions = createMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/application/hooks/useCreateRemark.ts
const createRemarkMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:requestId/final-decision/current-version/remarks" }];
function createRemarkMutationOptions(config = {}) {
	const mutationKey = createRemarkMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await createRemark({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Добавить замечание к текущей версии
* {@link /api/mdm/internal/api/internal/requests/:requestId/final-decision/current-version/remarks}
*/
function useCreateRemark(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? createRemarkMutationKey();
	const baseOptions = createRemarkMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/application/hooks/useDeleteAttachmentDescription.ts
const deleteAttachmentDescriptionMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:id/attachments/:fileId" }];
function deleteAttachmentDescriptionMutationOptions(config = {}) {
	const mutationKey = deleteAttachmentDescriptionMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await deleteAttachmentDescription({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Только OPERATOR, запрещено если заявка финализирована.
* @summary Удалить описание вложения
* {@link /api/mdm/internal/api/internal/requests/:id/attachments/:fileId}
*/
function useDeleteAttachmentDescription(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? deleteAttachmentDescriptionMutationKey();
	const baseOptions = deleteAttachmentDescriptionMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/application/hooks/useDeleteRemark.ts
const deleteRemarkMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:requestId/final-decision/current-version/remarks/:remarkId" }];
function deleteRemarkMutationOptions(config = {}) {
	const mutationKey = deleteRemarkMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await deleteRemark({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Логически удалить своё замечание к текущей версии
* {@link /api/mdm/internal/api/internal/requests/:requestId/final-decision/current-version/remarks/:remarkId}
*/
function useDeleteRemark(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? deleteRemarkMutationKey();
	const baseOptions = deleteRemarkMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/application/hooks/useExportRequests.ts
const exportRequestsMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/export" }];
function exportRequestsMutationOptions(config = {}) {
	const mutationKey = exportRequestsMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await exportRequests({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description         Формирует один ZIP-архив: на каждую заявку — папка request_<id>
*         (outcome.json, comments.json и файлы результата). Доступно только OPERATOR.
*         Только для заявок в статусе REVISION_REQUIRED/TU_ISSUED/REJECTED. Fail-fast: любая невалидная
*         заявка отменяет весь экспорт (ничего не стримится).
* @summary Пакетный экспорт результата заявок
* {@link /api/mdm/internal/api/internal/requests/export}
*/
function useExportRequests(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? exportRequestsMutationKey();
	const baseOptions = exportRequestsMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/application/hooks/useGet2.ts
const get2QueryKey = ({ path }) => [{
	url: "/api/mdm/internal/api/internal/requests/:requestId/final-decision",
	params: path
}];
function get2QueryOptions({ path }, config = {}) {
	const queryKey = get2QueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await get2({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить черновик итогового решения
* {@link /api/mdm/internal/api/internal/requests/:requestId/final-decision}
*/
function useGet2({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? get2QueryKey(resolvedParams);
	const queryResult = useQuery({
		...get2QueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useGetCounts.ts
const getCountsQueryKey = () => [{ url: "/api/mdm/internal/api/internal/requests/counts" }];
function getCountsQueryOptions(config = {}) {
	const queryKey = getCountsQueryKey();
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getCounts({
				...config,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description         Агрегат count(*) по статусам в скоупе роли: OPERATOR — все заявки;
*         SECRETARY_NG и APPARATUS_NG — только заявки дороги, сопоставленной с дорогой
*         пользователя в Keycloak; NTP_HEAD, NTP_RESPONSIBLE и прочие — только заявки
*         со своим назначением (без назначений — нули).
*         needsAttention = REVISION_REQUIRED (на доработке у заявителя).
*         tiles — ролевые плашки: SECRETARY_NG — 5 (TOTAL/NEW/NEEDS_ATTENTION/AT_NG/AT_RAILWAY),
*         APPARATUS_NG — 6 (TOTAL/SENT_TO_NG/IN_NG/IN_NTP/NG_APPROVAL/DECISION_REWORK),
*         NTP_HEAD — 5 (TOTAL/SENT_TO_NTP/IN_NTP/NTP_APPROVAL/DECISION_REWORK),
*         NTP_RESPONSIBLE — 5 (TOTAL/NTP_RESP_ASSIGNED/COMMISSION_PREP/DECISION_FORMING/DECISION_REWORK),
*         OPERATOR — 4 (TOTAL/NEEDS_EXPORT/EXPORTED/LOADED),
*         прочие роли — null.
* @summary Сводка-счётчики заявок по статусам
* {@link /api/mdm/internal/api/internal/requests/counts}
*/
function useGetCounts(options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = resolvedOptions?.queryKey ?? getCountsQueryKey();
	const queryResult = useQuery({
		...getCountsQueryOptions(config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useGetCurrentVersion.ts
const getCurrentVersionQueryKey = ({ path }) => [{
	url: "/api/mdm/internal/api/internal/requests/:requestId/final-decision/current-version",
	params: path
}];
function getCurrentVersionQueryOptions({ path }, config = {}) {
	const queryKey = getCurrentVersionQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getCurrentVersion({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить текущую версию итогового решения
* {@link /api/mdm/internal/api/internal/requests/:requestId/final-decision/current-version}
*/
function useGetCurrentVersion({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getCurrentVersionQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getCurrentVersionQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useGetFilterValues.ts
const getFilterValuesQueryKey = ({ query }) => [{ url: "/api/mdm/internal/api/internal/requests/filter-values" }, ...query ? [query] : []];
function getFilterValuesQueryOptions({ query }, config = {}) {
	const queryKey = getFilterValuesQueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getFilterValues({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Значения для выпадающих списков фильтров, которые нельзя составить
* заранее: станция/перегон (SECTION), заявитель (APPLICANT_NAME),
* инициатор (INITIATOR), ответственный (ASSIGNEE), оператор (OPERATOR).
* Возвращаются только значения, встречающиеся в видимых пользователю
* заявках — скоуп тот же, что у списка. Для колонок-людей value — id
* пользователя (его и надо слать в initiatorIds/assigneeIds/operatorIds),
* displayName — ФИО. «Не назначен» не приходит этим списком: для него в
* GET /api/internal/requests передаётся assigneeUnassigned=true
* (для «Оператора» — operatorUnassigned=true).
* Поиск q — подстрока без учёта регистра. Для станции, заявителя и
* инициатора — по отображаемому значению из БД. Для «Ответственного» и
* «Оператора» ФИО живёт в Keycloak, поэтому ищется по директории: фамилия, имя,
* логин или email (отчество не участвует), с последующим сужением до
* видимых заявок — размер выборки поиску не помеха.
* selected — уже выбранные значения, теми же строками, что пришли в value.
* Возвращаются всегда, вне q и limit.
* При переходе из мониторинга передавайте monitoringMetric, как в GET /requests:
* для НТП значения будут доступны по своей дороге вместо личных назначений.
* Значения ограничиваются областью доступа, а не выбранным показателем.
* @summary Доступные значения фильтра по колонке
* {@link /api/mdm/internal/api/internal/requests/filter-values}
*/
function useGetFilterValues({ query }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? getFilterValuesQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getFilterValuesQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useGetHistory.ts
const getHistoryQueryKey = ({ path }) => [{
	url: "/api/mdm/internal/api/internal/requests/:id/history",
	params: path
}];
function getHistoryQueryOptions({ path }, config = {}) {
	const queryKey = getHistoryQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getHistory({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Журнал событий (eventType, actor, actorRole, payload, occurredAt),
* отсортированный по убыванию времени. Доступ как у detail: OPERATOR/MONITORING — любую;
* SECRETARY_NG и APPARATUS_NG — свою дорогу; NTP_HEAD — свои назначения или свою дорогу;
* NTP_RESPONSIBLE и прочие — только при наличии назначения на заявке.
* @summary История действий по заявке (F-INT-03)
* {@link /api/mdm/internal/api/internal/requests/:id/history}
*/
function useGetHistory({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getHistoryQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getHistoryQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useGetNeedsAttention.ts
const getNeedsAttentionQueryKey = ({ query } = {}) => [{ url: "/api/mdm/internal/api/internal/requests/needs-attention" }, ...query ? [query] : []];
function getNeedsAttentionQueryOptions({ query } = {}, config = {}) {
	const queryKey = getNeedsAttentionQueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getNeedsAttention({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Заявки, требующие действий текущего пользователя по его роли. Видимость:
* OPERATOR — все заявки; SECRETARY_NG и APPARATUS_NG — только заявки дороги,
* сопоставленной с дорогой пользователя в Keycloak; NTP_HEAD, NTP_RESPONSIBLE
* и прочие — только заявки со своим назначением.
* Заявитель отсутствует во внутреннем контуре; Секретарь НГ — INTAKE_CHECK;
* Аппарат НГ / НТП / Отв. НТП — статус ОБЯЗАН входить в фиксированный набор
* (Аппарат НГ: SENT_TO_NG/NG_APPROVAL; НТП: SENT_TO_NTP/NTP_APPROVAL;
* Отв. НТП: NTP_RESP_ASSIGNED/DECISION_REWORK) И пользователь ОБЯЗАН держать
* слот, которому принадлежит текущий статус заявки — оба условия одновременно;
* взятые в работу статусы (IN_NG, IN_NTP, COMMISSION_PREP, DECISION_FORMING)
* в очередь не входят, даже если пользователь держит их слот; Оператор —
* требующие выгрузки. Ролевые условия по статусу и держателю слота дополнительно
* пересекаются с указанной видимостью и не расширяют её.
* Роль без блока → пустой список. totalElements = число в заголовке блока.
* Поиск search — как в GET /requests: вхождение в название без учёта регистра и в number.
* Для роли MONITORING блока нет — возвращается пустой список.
* @summary Блок «Требует внимания»
* {@link /api/mdm/internal/api/internal/requests/needs-attention}
*/
function useGetNeedsAttention({ query } = {}, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? getNeedsAttentionQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getNeedsAttentionQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useGetRefusal.ts
const getRefusalQueryKey = ({ path }) => [{
	url: "/api/mdm/internal/api/internal/requests/:requestId/final-decision/refusal",
	params: path
}];
function getRefusalQueryOptions({ path }, config = {}) {
	const queryKey = getRefusalQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getRefusal({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить мотивированный отказ
* {@link /api/mdm/internal/api/internal/requests/:requestId/final-decision/refusal}
*/
function useGetRefusal({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getRefusalQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getRefusalQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useGetRequest.ts
const getRequestQueryKey = ({ path }) => [{
	url: "/api/mdm/internal/api/internal/requests/:id",
	params: path
}];
function getRequestQueryOptions({ path }, config = {}) {
	const queryKey = getRequestQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getRequest({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description         Возвращает детальную информацию о заявке по идентификатору.
*         OPERATOR/MONITORING — любую заявку; SECRETARY_NG и APPARATUS_NG — свою дорогу.
*         NTP_HEAD — свои назначения, а также заявки своей дороги для переходов из мониторинга.
*         NTP_RESPONSIBLE и прочие — только при наличии своего назначения.
* @summary Детали заявки (F-INT-03)
* {@link /api/mdm/internal/api/internal/requests/:id}
*/
function useGetRequest({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getRequestQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getRequestQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useGetRequests.ts
const getRequestsQueryKey = ({ query } = {}) => [{ url: "/api/mdm/internal/api/internal/requests" }, ...query ? [query] : []];
function getRequestsQueryOptions({ query } = {}, config = {}) {
	const queryKey = getRequestsQueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getRequests({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description         Возвращает пагинированный список заявок. Фильтры (AND): status, type,
*         requestSubject, railway, applicantType, sections/applicantNames (точные
*         значения из списка доступных), initiatorIds/assigneeIds/operatorIds
*         (id пользователей), paymentFlag, processingFlag, deadlineControl, периоды
*         importedFrom/To, processedFrom/To, createdFrom/To, updatedFrom/To (обе
*         границы включительно; «конкретную дату» фронт присылает как границы своего
*         дня) и reviewDueFrom/To (границы — ISO-даты, колонка хранит дату без времени).
*         Дата обработки и контроль срока вычисляемые: фильтруются тем же выражением,
*         которое показано в ячейке.
*         Параметры section/applicantName/initiator (ILIKE-подстроки) устарели —
*         используйте множественные аналоги.
*         assigneeUnassigned=true добавляет заявки без ответственного; вместе с assigneeIds
*         это объединение выбранных ответственных и нераспределённых заявок.
*         operatorUnassigned=true аналогично добавляет заявки без оператора.
*         Доступные значения фильтров: закрытые наборы — GET /api/internal/dictionaries,
*         остальное — GET /api/internal/requests/filter-values.
*         Поиск search — вхождение в название заявки (title, без учёта регистра)
*         и number; поддерживается ввод №012345. Сортировка sortBy/sortDir (дефолт — imported_at DESC),
*         вторичный ключ id. sortDir принимает строго ASC или DESC — значение
*         регистрозависимо, ?sortDir=asc вернёт 400. sortDir без sortBy игнорируется;
*         sortBy без sortDir — ASC. TYPE/STATUS/RAILWAY сортируются по отображаемому
*         названию, текстовые поля — без учёта регистра. Видимость по роли: OPERATOR/MONITORING — все заявки;
*         сортировка по ASSIGNEE использует имя из последнего назначения текущего слота,
*         по OPERATOR — snapshot ФИО последнего операторского события;
*         SECRETARY_NG и APPARATUS_NG — только заявки дороги, сопоставленной с дорогой
*         пользователя в Keycloak; NTP_HEAD, NTP_RESPONSIBLE и прочие — только заявки
*         со своим назначением. Для роли OPERATOR дополнительно заполняются
*         processingFlag/receivedAt/processedAt/operator; какие из этого набора колонок
*         показывать — решает фронт через настройки таблицы (контекст operator_requests).
*         monitoringMetric включает область мониторинга: НТП и Аппарат НГ — своя дорога,
*         Мониторинг — все дороги. Без monitoringMetric НТП видит только свои назначения.
*         Для всей области мониторинга используйте monitoringMetric=TOTAL.
*         Показатель, поиск, invoiceAmountFrom/To и прочие фильтры сочетаются через AND.
* @summary Список заявок (F-INT-03)
* {@link /api/mdm/internal/api/internal/requests}
*/
function useGetRequests({ query } = {}, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? getRequestsQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getRequestsQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useGetVersions.ts
const getVersionsQueryKey = ({ path }) => [{
	url: "/api/mdm/internal/api/internal/requests/:requestId/final-decision/versions",
	params: path
}];
function getVersionsQueryOptions({ path }, config = {}) {
	const queryKey = getVersionsQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getVersions({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить историю версий итогового решения
* {@link /api/mdm/internal/api/internal/requests/:requestId/final-decision/versions}
*/
function useGetVersions({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getVersionsQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getVersionsQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useImportRequest.ts
const importRequestMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/import" }];
function importRequestMutationOptions(config = {}) {
	const mutationKey = importRequestMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await importRequest({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Загружает ZIP-архив (одна или несколько заявок в папках request_<id>/) из внешнего контура. Создаёт новые и обновляет существующие заявки, возвращает сводку. Некорректные заявки пропускаются.
* @summary Импорт ZIP-архива заявок (мультизаявочный)
* {@link /api/mdm/internal/api/internal/requests/import}
*/
function useImportRequest(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? importRequestMutationKey();
	const baseOptions = importRequestMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/application/hooks/useList.ts
const listQueryKey = ({ path }) => [{
	url: "/api/mdm/internal/api/internal/requests/:requestId/tu-parts",
	params: path
}];
function listQueryOptions({ path }, config = {}) {
	const queryKey = listQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await list({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить все строки частей ТУ заявки
* {@link /api/mdm/internal/api/internal/requests/:requestId/tu-parts}
*/
function useList({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? listQueryKey(resolvedParams);
	const queryResult = useQuery({
		...listQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useListAttachmentDescriptions.ts
const listAttachmentDescriptionsQueryKey = ({ path }) => [{
	url: "/api/mdm/internal/api/internal/requests/:id/attachments",
	params: path
}];
function listAttachmentDescriptionsQueryOptions({ path }, config = {}) {
	const queryKey = listAttachmentDescriptionsQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await listAttachmentDescriptions({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description         Список {fileId, description}. Доступ как у detail: OPERATOR/MONITORING — любую;
*         SECRETARY_NG и APPARATUS_NG — свою дорогу; NTP_HEAD — свои назначения или свою дорогу;
*         NTP_RESPONSIBLE и прочие — только при наличии назначения на заявке.
* @summary Описания вложений заявки
* {@link /api/mdm/internal/api/internal/requests/:id/attachments}
*/
function useListAttachmentDescriptions({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? listAttachmentDescriptionsQueryKey(resolvedParams);
	const queryResult = useQuery({
		...listAttachmentDescriptionsQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/application/hooks/useSetAttachmentDescription.ts
const setAttachmentDescriptionMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:id/attachments/:fileId" }];
function setAttachmentDescriptionMutationOptions(config = {}) {
	const mutationKey = setAttachmentDescriptionMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await setAttachmentDescription({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Upsert описания файла. Только OPERATOR, запрещено если заявка финализирована.
* @summary Установить описание вложения
* {@link /api/mdm/internal/api/internal/requests/:id/attachments/:fileId}
*/
function useSetAttachmentDescription(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? setAttachmentDescriptionMutationKey();
	const baseOptions = setAttachmentDescriptionMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/application/hooks/useTransition.ts
const transitionMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:requestId/transitions/:action" }];
function transitionMutationOptions(config = {}) {
	const mutationKey = transitionMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await transition({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description         Выполняет действие-триггер перехода жизненного цикла заявки (STORY-975).
*         Допустимость перехода и требуемая роль инициатора определяются матрицей
*         переходов; действует жёсткий gating по паре (статус × роль) — недопустимое
*         действие или отсутствие роли завершаются ошибкой 409. Если у текущего статуса
*         есть слот-держатель, действие выполняет только он; переназначить держателя без
*         смены статуса можно через `PUT /assignments/{slot}`, а если слот текущего
*         статуса ещё не занят — ответ 409 `ASSIGNMENT_NOT_FOUND`. Для статусов без
*         слота (`INTAKE_CHECK`, `REVISION_REQUIRED`) держателя нет — достаточно роли
*         и скоупа доступа.
*         Тело запроса — `TransitionCommand{comment, resultFileId, assigneeId, documentIds}`.
*         `comment` — текст замечаний/отказа, `resultFileId` — опциональный id файла
*         результата (ТУ), привязанного к заявке. Для `ntp-rework`/`ng-rework` обязателен непустой
*         `comment`, а `documentIds` содержит опциональные документы замечания.
*         `assigneeId` — исполнитель, назначаемый в слот:
*         обязателен для действий, заполняющих слот (`intake-pass`, `send-to-ntp`,
*         `assign-ntp-resp`, отмечены в таблице ниже) — без него 409
*         `ASSIGNEE_REQUIRED`; роль назначаемого проверяется в Keycloak — пользователь
*         не найден даёт `ASSIGNEE_NOT_FOUND`, несоответствие роли слоту —
*         `ASSIGNEE_ROLE_MISMATCH`. Для остальных действий тело опционально.
*         Перечень действий (`action` в пути):
*         | action | Переход статуса | Роль | Исполнитель | За что отвечает |
*         |---|---|---|---|---|
*         | `intake-pass` | INTAKE_CHECK → SENT_TO_NG | Секретарь НГ | обязателен | Входной контроль пройден, заявка направлена в аппарат НГ |
*         | `request-revision` | INTAKE_CHECK / IN_NG → REVISION_REQUIRED | Секретарь НГ / Аппарат НГ | — | Возврат заявителю на доработку; сохраняет точку возврата (return_stage) и `comment` с замечаниями |
*         | `reject` | INTAKE_CHECK / IN_NG / NG_APPROVAL → REJECTED | Секретарь НГ / Аппарат НГ | — | Мотивированный отказ (терминальный); обязателен `comment` — причина, опциональны `documentIds` |
*         | `take-ng` | SENT_TO_NG → IN_NG | Аппарат НГ | — | Взятие заявки в работу аппаратом НГ |
*         | `send-to-ntp` | IN_NG → SENT_TO_NTP | Аппарат НГ | обязателен | Направление заявки в НТП |
*         | `take-ntp` | SENT_TO_NTP → IN_NTP | Начальник НТП | — | Взятие заявки в работу в НТП |
*         | `assign-ntp-resp` | IN_NTP → NTP_RESP_ASSIGNED | Начальник НТП | обязателен | Назначение ответственного исполнителя в НТП |
*         | `start-commission-prep` | NTP_RESP_ASSIGNED → COMMISSION_PREP | Ответственный НТП | — | Старт подготовки комиссии |
*         | `start-decision` | COMMISSION_PREP → DECISION_FORMING | Ответственный НТП | — | Переход к формированию решения |
*         | `submit-ntp-approval` | DECISION_FORMING → NTP_APPROVAL | Ответственный НТП | — | Отправка сформированного решения на согласование НТП |
*         | `ntp-rework` | NTP_APPROVAL → DECISION_REWORK | Начальник НТП | — | Immutable `RETURNED` + замечание; обязательны `comment`, опциональны `documentIds` |
*         | `ntp-approve` | NTP_APPROVAL → NG_APPROVAL | Начальник НТП | — | Immutable `APPROVED`; решение передано на согласование НГ |
*         | `ng-rework` | NG_APPROVAL → DECISION_REWORK | Аппарат НГ | — | Immutable `RETURNED` + замечание; обязательны `comment`, опциональны `documentIds` |
*         | `ng-approve` | NG_APPROVAL → TU_ISSUED / REJECTED | Аппарат НГ | — | Immutable `APPROVED`; terminal status берётся из decision текущей версии, `resultFileId` опционален |
*         | `rework-resubmit` | DECISION_REWORK → NTP_APPROVAL / NG_APPROVAL | Ответственный НТП | — | Создаёт следующую immutable версию и возвращает на этап последнего `RETURNED` |
*         `take-ng` и `take-ntp` — «авто»-действия (взятие в работу), остальные инициируются вручную.
* @summary Выполнить переход статуса заявки
* {@link /api/mdm/internal/api/internal/requests/:requestId/transitions/:action}
*/
function useTransition(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? transitionMutationKey();
	const baseOptions = transitionMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/application/hooks/useUnlink.ts
const unlinkMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:requestId/tu-parts/:fileId" }];
function unlinkMutationOptions(config = {}) {
	const mutationKey = unlinkMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await unlink({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Отвязать актуальную часть ТУ
* {@link /api/mdm/internal/api/internal/requests/:requestId/tu-parts/:fileId}
*/
function useUnlink(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? unlinkMutationKey();
	const baseOptions = unlinkMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/application/hooks/useUpdate.ts
const updateMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:requestId/final-decision" }];
function updateMutationOptions(config = {}) {
	const mutationKey = updateMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await update({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Изменить черновик итогового решения
* {@link /api/mdm/internal/api/internal/requests/:requestId/final-decision}
*/
function useUpdate(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? updateMutationKey();
	const baseOptions = updateMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
export { exportRequestsMutationOptions as $, useGetRequest as A, getFilterValuesQueryKey as B, getVersionsQueryOptions as C, useGetRequests as D, getRequestsQueryOptions as E, getNeedsAttentionQueryOptions as F, useGetCurrentVersion as G, useGetFilterValues as H, useGetNeedsAttention as I, useGetCounts as J, getCountsQueryKey as K, getHistoryQueryKey as L, getRefusalQueryOptions as M, useGetRefusal as N, getRequestQueryKey as O, getNeedsAttentionQueryKey as P, exportRequestsMutationKey as Q, getHistoryQueryOptions as R, getVersionsQueryKey as S, getRequestsQueryKey as T, getCurrentVersionQueryKey as U, getFilterValuesQueryOptions as V, getCurrentVersionQueryOptions as W, get2QueryOptions as X, get2QueryKey as Y, useGet2 as Z, listQueryOptions as _, unlinkMutationOptions as a, deleteAttachmentDescriptionMutationOptions as at, importRequestMutationOptions as b, transitionMutationOptions as c, createRemarkMutationOptions as ct, setAttachmentDescriptionMutationOptions as d, createMutationOptions as dt, useExportRequests as et, useSetAttachmentDescription as f, useCreate as ft, listQueryKey as g, useListAttachmentDescriptions as h, useBind as ht, unlinkMutationKey as i, deleteAttachmentDescriptionMutationKey as it, getRefusalQueryKey as j, getRequestQueryOptions as k, useTransition as l, useCreateRemark as lt, listAttachmentDescriptionsQueryOptions as m, bindMutationOptions as mt, updateMutationOptions as n, deleteRemarkMutationOptions as nt, useUnlink as o, useDeleteAttachmentDescription as ot, listAttachmentDescriptionsQueryKey as p, bindMutationKey as pt, getCountsQueryOptions as q, useUpdate as r, useDeleteRemark as rt, transitionMutationKey as s, createRemarkMutationKey as st, updateMutationKey as t, deleteRemarkMutationKey as tt, setAttachmentDescriptionMutationKey as u, createMutationKey as ut, useList as v, useGetVersions as w, useImportRequest as x, importRequestMutationKey as y, useGetHistory as z };

//# sourceMappingURL=useUpdate.js.map